import 'flag-icons/css/flag-icons.min.css';

/** Bandera SVG (flag-icons). Los emojis de bandera no se dibujan en Windows y salen como letras ("MX"). */
export function Flag({ iso, className }: { iso: string; className?: string }) {
  return (
    <span
      className={`fi fi-${iso.toLowerCase()}${className ? ` ${className}` : ''}`}
      style={{ borderRadius: 2, flexShrink: 0, display: 'inline-block' }}
      aria-hidden="true"
      data-testid={`flag-${iso.toUpperCase()}`}
    />
  );
}
